export const sfBenchmark: Record<string, number> = {
    'Product Engineer': 243000,
    'Account Executive (OTE)': 300000,
    'Backend Engineer': 243000,
    'Billing Support Specialist': 154619,
    'Business Development Representative (OTE)': 182000,
    'Content Marketer': 190910,
    'Community Manager': 185000,
    'Customer Success Manager (OTE)': 211000,
    'Data Engineer': 243000,
    'Design Lead': 236000,
    'Events Manager': 165000,
    'Finance Manager': 181680,
    'Front End Developer': 212000,
    'Full Stack Engineer': 243000,
    'Graphic Designer': 147530,
    'Mobile Engineer': 243000,
    'Onboarding Specialist': 211000,
    'Operations & Finance Lead': 225000,
    'Operations Manager': 181680,
    'People Operations Manager': 153311,
    'Performance Marketer': 160680,
    'Product Designer': 186000,
    'Product Manager': 213600,
    'Product Marketer': 218000,
    'Revenue Ops Manager': 192000,
    'Site Reliability Engineer': 236000,
    'Support Engineer': 189000,
    'Talent Partner': 210000,
    'Video Producer': 166800,
}
